import { AxiosPromise } from "axios";
import {
  LightCardDto,
  LocationDto,
  BrandDto,
  PaymentDetailsDto,
  PurchaseDto,
  SubStatusDto,
  UpdateCardDto,
  UserDetailsDto,
  PrintDto,
  FullBillingDto,
  AddOnDtoTypeEnum,
  AddOnDto,
  PriceDto,
  SubStatusDtoPlanCycleEnum,
  UpgradeSubscriptionDto, MemberDto
} from "../generated/dashboard-client";
import { dashboardApiConfig, ops } from "./config";
import { AccountsResourceApi } from "../generated/dashboard-client";

const api = new AccountsResourceApi(dashboardApiConfig);

const AccountsApi = {
  getPaymentDetails(memberId: string): AxiosPromise<PaymentDetailsDto> {
    return api.getAccountPaymentDetails(memberId, ops());
  },

  getSubscription(memberId: string): AxiosPromise<SubStatusDto> {
    return api.getSubscription(memberId, ops());
  },

  getPrimaryUserLocation(memberId: number): AxiosPromise<LocationDto> {
    return api.getPrimaryUserLocation(memberId, ops());
  },

  setPrimaryUserLocation(
    memberId: number,
    locationId: number
  ): AxiosPromise<void> {
    return api.setPrimaryUserLocation(memberId, locationId, ops());
  },

  getAvailableSubscriptions(memberId: string): AxiosPromise<SubStatusDto[]> {
    return api.getAvailableSubscriptions(memberId, ops());
  },

  changeSubscriptionPlan(
    memberId: string,
    cycle: SubStatusDtoPlanCycleEnum,
    preview: boolean
  ): AxiosPromise<SubStatusDto> {
    return api.changeSubscriptionPlan(memberId, preview, cycle, ops());
  },

  saveFullBillingInfo(
    memberId: string,
    dto: FullBillingDto
  ): AxiosPromise<void> {
    return api.saveFullBillingInfo(memberId, dto, ops());
  },

  validateBilling(memberId: string, dto: UpgradeSubscriptionDto): AxiosPromise<SubStatusDto> {
    return api.validateBilling(memberId, dto, ops());
  },

  getUsersDetails(memberId: string, status: string = "",  currentPage: number = 1, pageSize: number = 100, key: string = "", locationIds: number[] = [], presetIds: string[] = [], permissions: string[] = []): AxiosPromise<UserDetailsDto> {
    return api.getUsersDetails(memberId, currentPage, status, pageSize, key, locationIds, presetIds, permissions, ops());
  },

  getUserInfo(memberId: string): AxiosPromise<MemberDto> {
    return api.getUserInfo(memberId, ops());
  },

  updatePermissions(memberId: string, members: MemberDto[]): AxiosPromise<boolean> {
    return api.updatePermissions(memberId, members, ops());
  },

  getUserLocations(memberId: string): AxiosPromise<LocationDto[]> {
    return api.getUserLocations(memberId, ops());
  },

  getUserLocationsLight(memberId: string): AxiosPromise<LocationDto[]> {
    return api.getUserLocationsLight(memberId, ops());
  },

  getUserLocationsWithLogos(memberId: string): AxiosPromise<LocationDto[]> {
    return api.getUserLocationsWithLogos(memberId, ops());
  },

  getTeamLocations(memberId: string): AxiosPromise<LocationDto[]> {
    return api.getUserLocations(memberId, ops());
  },

  getUserBrands(memberId: string): AxiosPromise<BrandDto[]> {
    return api.getUserBrands(memberId, ops());
  },

  getPurchases(memberId: string): AxiosPromise<PurchaseDto[]> {
    return api.getAccountPurchases(memberId, ops());
  },

  getInvoice(memberId: string, transactionId: string): AxiosPromise<void> {
    return api.getAccountPurchaseInvoicePDF(memberId, transactionId, {
      ...ops(),
      responseType: "blob",
    });
  },

  getReceipt(memberId: string, transactionId: string): AxiosPromise<void> {
    return api.getAccountPurchaseReceiptPDF(memberId, transactionId, {
      ...ops(),
      responseType: "blob",
    });
  },

  getPrintHistory(memberId: string): AxiosPromise<PrintDto[]> {
    return api.getAccountPrintHistory(memberId, ops());
  },

  updateCard(memberId: string, dto: UpdateCardDto): AxiosPromise<LightCardDto> {
    return api.updateAccountPaymentDetailsCard(memberId, dto, ops());
  },

  addSubscriptionAddon(
    memberId: string,
    type: AddOnDtoTypeEnum,
    qty: number,
    preview: boolean
  ): AxiosPromise<SubStatusDto> {
    return api.addSubscriptionAddon(memberId, preview, qty, type, undefined, ops());
  },

  removeSubscriptionAddon(
    memberId: string,
    type: AddOnDtoTypeEnum
  ): AxiosPromise<void> {
    return api.removeSubscriptionAddon(memberId, type, ops());
  },

  getSubscriptionAddons(memberId: string): AxiosPromise<AddOnDto[]> {
    return api.getSubscriptionAddons(memberId, ops());
  },

  getAvailablePrices(memberId: string): AxiosPromise<PriceDto[]> {
    return api.getAvailablePrices(memberId, ops());
  },

  getTeamAvailableSeats(teamId: string): AxiosPromise<number> {
    return api.getTeamAvailableSeats(teamId, ops());
  },
};

export default AccountsApi;
